'use client';
import { jsx } from 'react/jsx-runtime';
import { Slot } from '@radix-ui/react-slot';
import { forwardRef } from 'react';

/**
 * PaginationItem component, use within a Pagination.List.
 *
 * @example
 * <PaginationList>
 *   <PaginationItem>
 *     <PaginationButton aria-label='Forrige side'>Forrige</PaginationButton>
 *   </PaginationItem>
 * </PaginationList>
 */
const PaginationItem = forwardRef(function PaginationItem({ asChild, className, ...rest }, ref) {
    const Component = asChild ? Slot : 'li';
    return jsx(Component, { ref: ref, ...rest });
});

export { PaginationItem };
